import { CollapsedPanelHeight, ColumnKey_LeftColumn, ColumnKey_MiddleColumn, LeftColumn_AllClosed, LeftColumn_EventFeedOpen, LeftColumn_SmartDocsOpen, MiddleColumn_Findings, PanelKey_EventFeed, PanelKey_Findings, PanelKey_PatientDataLoader, PanelKey_SmartDocs } from '@app/advisor-v5-shared';
import { ModuleFE_AdvisorBoard } from './ModuleFE_AdvisorBoard.js';
export const Board_SmartDocs = {
    isOpen: () => {
        return ModuleFE_AdvisorBoard.getPanelItem(PanelKey_SmartDocs)?.height !== 0;
    },
    open: () => {
        if (Board_SmartDocs.isOpen())
            return;
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_LeftColumn, LeftColumn_SmartDocsOpen);
    },
    close: () => {
        if (!Board_SmartDocs.isOpen())
            return;
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_LeftColumn, LeftColumn_AllClosed);
    }
};
export const Board_EventFeed = {
    isOpen: () => {
        return ModuleFE_AdvisorBoard.getPanelItem(PanelKey_EventFeed)?.height !== 0;
    },
    open: () => {
        if (Board_EventFeed.isOpen())
            return;
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_LeftColumn, LeftColumn_EventFeedOpen);
    },
    close: () => {
        if (!Board_EventFeed.isOpen())
            return;
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_LeftColumn, LeftColumn_AllClosed);
    }
};
export const Board_PatientDataLoader = {
    isOpen: () => {
        return ModuleFE_AdvisorBoard.getPanelItem(PanelKey_PatientDataLoader)?.height === CollapsedPanelHeight;
    },
    open: () => {
        return ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_MiddleColumn, [
            { panelKey: PanelKey_Findings, height: 1 },
            { panelKey: PanelKey_PatientDataLoader, height: CollapsedPanelHeight }
        ]);
    },
    close: () => {
        return ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_MiddleColumn, MiddleColumn_Findings);
    }
};
//# sourceMappingURL=utils.js.map